<script setup>
import { reactive, ref, watch, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import indexFormConfig, {
  customInputs,
  webAppFormConfig,
  securityFormConfig,
  fulfilmentFormConfig,
  facilitiesFormConfig,
  officeFormConfig,
  dataFormConfig,
  detailsFormConfig,
} from '../forms'

const route = useRoute()
const { $auth, $api, $urls } =
  getCurrentInstance().appContext.config.globalProperties
const submitted = ref(false)
let formData = reactive({ incidentForms: {} })
const incidentDetail = reactive({ severity: {}, retro: false })
const ticket = reactive({})

watch(
  formData,
  forms => {
    let severity = ''
    const { incidentForms } = forms

    switch (incidentForms.type) {
      case 'Technology':
        if (incidentForms.webAppOrdersDecrease === 'yes') {
          severity = '1'
        } else if (incidentForms.majorFeatureUnavailable === 'yes') {
          severity = '2'
        } else if (incidentForms.issueMultiplePeople === 'yes') {
          severity = '3'
        } else {
          severity = ''
        }
        break
      case 'Security':
        if (
          incidentForms.securityRansomware === 'yes' ||
          incidentForms.securityInfrastructureDisruptions === 'yes' ||
          incidentForms.securityDataBreach === 'yes'
        ) {
          severity = '1'
        } else if (incidentForms.securityMalwareOutbreak === 'yes') {
          severity = '2'
        } else if (
          incidentForms.securityMalwareInfection === 'yes' ||
          incidentForms.securityPhishingAttack === 'yes' ||
          incidentForms.securityUnauthorisedAccess === 'yes' ||
          incidentForms.securityDenialOfServiceAttack === 'yes' ||
          incidentForms.securityCompromisedSecurity === 'yes' ||
          incidentForms.securityLostOrStolenAsset === 'yes'
        ) {
          severity = '3'
        } else {
          severity = ''
        }
        break
      case 'Factory':
        if (
          !incidentForms.factoryStock &&
          !incidentForms.factoryAllCardLines &&
          !incidentForms.factoryAllGiftLines
        ) {
          severity = ''
        } else if (incidentForms.factoryStock === 'yes') {
          severity = '2'
        } else if (incidentForms.factoryStock === 'no') {
          severity = '3'
        } else if (
          incidentForms.factoryAllCardLines === 'yes' ||
          incidentForms.factoryAllGiftLines === 'yes'
        ) {
          severity =
            incidentForms.factoryPeakPeriod === 'yes' ||
            incidentForms.factoryCutOff === 'yes'
              ? '1'
              : '2'
        } else if (
          incidentForms.factoryAllCardLines === 'no' ||
          incidentForms.factoryAllGiftLines === 'no'
        ) {
          severity =
            incidentForms.factoryPeakPeriod === 'yes' ||
            incidentForms.factoryCutOff === 'yes'
              ? '2'
              : '3'
        } else {
          severity = ''
        }

        break
      case 'OfficeIt':
        if (incidentForms.officeTotalNetworkOutageFactory === 'yes') {
          severity = '1'
        } else if (
          incidentForms.officeTotalNetworkOutage === 'yes' ||
          incidentForms.officeCoreTech === 'yes'
        ) {
          severity = '2'
        } else if (incidentForms.officeNonCoreTech === 'yes') {
          severity = '3'
        } else {
          severity = ''
        }
        break
      case 'Facilities':
        if (
          incidentForms.facilitiesProductionDisruption === 'yes' ||
          incidentForms.facilitiesLifeThreateningInjury === 'yes'
        ) {
          severity = '1'
        } else if (incidentForms.facilitiesPartialLossOfAccess === 'yes') {
          severity = '2'
        } else {
          severity = ''
        }
        break
      case 'Data':
        if (incidentForms.snowflakeDown === 'yes') {
          severity = '2'
        } else if (
          incidentForms.ingestionToolingOutage === 'yes' ||
          incidentForms.dataTransformationToolingOutage === 'yes' ||
          incidentForms.reportingFailures === 'yes' ||
          incidentForms.externalIncidentIdentified === 'yes'
        ) {
          severity = incidentForms.dataPeakPeriod === 'yes' ? '2' : '3'
        } else {
          severity = ''
        }
        break
    }
    incidentDetail.retro = forms.retro
    incidentDetail.severity = severity
  },
  {
    flush: 'sync',
  },
)

const submitHandler = async form => {
  const { incidentForms } = form
  const accessToken = $auth.getAccessToken()

  try {
    const response = await $api.post(
      $urls.jira,
      {
        data: {
          incidentType: incidentForms.type,
          summary: form.summary,
          description: form.description,
          priority: 'Severity ' + incidentDetail.severity,
          affected: form.link,
          reporter: form.name,
          isRetro: form.retro,
          resolutionSteps: form.resolutionSteps,
          businessUpdate: form.businessUpdate,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-MoonpigGroupBrand': route.params.brand,
        },
      },
    )

    Object.assign(ticket, response.data.data)
    submitted.value = true
  } catch (err) {
    alert(err)
  }
}

const clickHandler = event => {
  if (event.target.tagName !== 'INPUT') {
    return
  }

  const nextSection = event.target.closest('section')?.nextElementSibling
  if (nextSection) {
    nextSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

const schema = [
  {
    $formkit: 'group',
    name: 'incidentForms',
    config: {
      classes: {
        fieldset: 'border-none',
        option: '  p-3 mb-2 list-unstyled',
        optionHelp: 'pt-3 text-muted text-center',
      },
    },
    children: [
      indexFormConfig,
      webAppFormConfig,
      securityFormConfig,
      fulfilmentFormConfig,
      officeFormConfig,
      facilitiesFormConfig,
      dataFormConfig,
    ],
  },
]

const detailsSchema = [
  {
    children: [detailsFormConfig],
  },
]
</script>

<template>
  <div>
    <div class="hero">
      <div class="container pt-5 pb-5 container-md">
        <div class="row">
          <div class="">
            <div class="card" v-if="!submitted">
              <div class="card-body p-5">
                <h1>Create a new Moonpig Group incident</h1>
                <div class="alert alert-info" role="alert">
                  This is the new incident site - please feedback in
                  <a
                    href="https://moonpig-group.slack.com/archives/C011BA58139"
                    class="alert-link"
                    >#mp-incident-management-process</a
                  >.
                </div>
                <div class="alert alert-info" role="alert">
                  Visit the handbook for more information on the
                  <a
                    class="alert-link"
                    href="https://greetz.atlassian.net/wiki/spaces/ENGINEERING/pages/2178220447/Incident+Management+Process"
                    >incident process</a
                  >.
                </div>
                <p class="font-weight-light">
                  Use this screen to create a new incident. This will create a
                  new ticket in the JIRA incidents board with further changes
                  and updates being managed there.
                </p>
                <hr />
                <FormKit
                  type="form"
                  v-model="formData"
                  @submit="submitHandler"
                  @click="clickHandler"
                  :actions="false"
                  :plugins="[customInputs]"
                >
                  <FormKitSchema :schema="schema" :data="formData" />
                  <FormKitSchema
                    :schema="detailsSchema"
                    :data="incidentDetail"
                  />
                </FormKit>
              </div>
            </div>

            <!-- message when submitted -->
            <div class="card" v-if="submitted">
              <div class="card-body p-5">
                <h1>Incident Created</h1>
                <p>
                  Thank you for taking the time to create the incident.
                  Depending on the type and severity, an email will be sent out
                  shortly notifying relevant parties of the incident.
                </p>
                <p>
                  If you would like to view the incident in JIRA, click
                  <a target="_blank" :href="ticket.jiraUrl">here</a>
                </p>

                <hr />

                <p><strong>Incident Id:</strong> {{ ticket.id }}</p>
                <p>
                  <strong>Type: </strong>
                  <Type
                    :title="ticket.incidentType"
                    :type="ticket.incidentType"
                    :showText="true"
                  ></Type>
                </p>
                <p><strong>Summary:</strong> {{ ticket.summary }}</p>
                <p><strong>Reported by:</strong> {{ ticket.reporter }}</p>
                <p>
                  <strong>Severity:</strong>
                  <Severity :severity="ticket.priorityLevel"></Severity>
                </p>
                <p>
                  <strong>Created: </strong>
                  {{
                    $moment(ticket.created).format('dddd Do MMMM YYYY HH:mm')
                  }}
                </p>
                <p>
                  <strong>Slack Channel: </strong>
                  <a v-if="ticket.slackChannelId"
                    :href="$urls.slack + ticket.slackChannelId.replace('#', '')"
                    target="_blank"
                    >{{ ticket.slackChannelName }}</a
                  >
                </p>
                <p>
                  <strong>Internal link to incident: </strong>
                  <router-link
                    :to="{ name: 'incident', params: { incident: ticket.id } }"
                    >{{ ticket.id }}</router-link
                  >
                </p>
                <p>
                  <strong>JIRA link to incident: </strong>
                  <a target="_blank" :href="$urls.jiraExternal[route.params.brand] + ticket.jiraUrl">{{
                      $urls.jiraExternal[route.params.brand] + ticket.jiraUrl
                  }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
